import { useQuery } from '@tanstack/react-query';

import { listHlSecurityMappings } from '../../lib/api/endpoints';

export const hlSecurityMappingKeys = {
  all: ['hl-security-mappings'] as const,
};

export function useHlSecurityMappings() {
  return useQuery({
    queryKey: hlSecurityMappingKeys.all,
    queryFn: listHlSecurityMappings,
  });
}
